import { TextField } from "@mui/material";

type Props = {
  value: string;
  onChange: (value: string) => void;
};

const VisitNoteInput = ({ value, onChange }: Props) => {
  return <TextField
    value={value}
    onChange={(event: React.ChangeEvent<HTMLInputElement>) => onChange(event.target.value)}
    placeholder="Reason for visit, caregiver must be present…"
    multiline
    fullWidth
    maxRows={3}
    style={{ backgroundColor: "white" }}
  />;
}

export default VisitNoteInput;
